<template>
    <transition name="el-fade-in-linear">
        <div v-show="showMain" class="transition-box">
            <div id="singleblock" style="overflow-x: hidden">
                <!--公司/門店基本資料-->
                <el-dialog :title="dialogTitle" width="550px" v-model="dialogFormVisible" :show-close="false" top="1vh" :visible="true"
                           center :close-on-click-modal="false" :lock-scroll="false" style="height: calc(98vh - 220px); margin-bottom: 1vh">
                    <el-form :model="form" :rules="rules" label-width="" ref="formRef" :inline-message="true" label-position="top">
                        <el-scrollbar height="calc(98vh - 384px)" wrap-style="overflow-x:hidden;">
                            <el-row>
                                <el-col :span="12" style="padding: 0 6px;">
                                    <el-form-item label="公司/門店代號" prop="VENDOR_ID">
                                        <el-input v-model="form.VENDOR_ID" disabled></el-input>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="6" style="padding: 0 6px;">
                                    <el-form-item label="餐飲平台" prop="CUST_CODE">
                                        <el-select v-model="form.CUST_CODE" style="width:100%;" disabled>
                                            <el-option v-for="item in custcodeOptions" :key="item.value" :label="item.label" :value="item.value"></el-option>
                                        </el-select>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="6" style="padding: 0 6px;">
                                    <el-form-item label="公司/門店狀態" prop="DISABLE_FG">
                                        <el-select v-model="form.DISABLE_FG" style="width:100%;">
                                            <el-option label="啟用中" value="N"></el-option>
                                            <el-option label="停用中" value="Y"></el-option>
                                        </el-select>
                                    </el-form-item>
                                </el-col>
                            </el-row>
                            <el-row>
                                <el-col :span="12" style="padding: 0 6px;">
                                    <el-form-item label="品牌名稱" prop="BRAND_NAME">
                                        <el-select v-model="form.BRAND_NAME" clearable style="width:100%;" disabled>
                                            <el-option v-for="item in brandOptions" :key="item.value" :label="item.label" :value="item.label"></el-option>
                                        </el-select>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="12" style="padding: 0 6px;">
                                    <el-form-item label="公司/門店名稱" prop="NAME">
                                        <el-input v-model="form.NAME"></el-input>
                                    </el-form-item>
                                </el-col>
                            </el-row>
                            <el-row>
                                <el-col :span="24" style="padding: 0 6px;">
                                    <el-form-item label="地址" prop="ADDRESS">
                                        <el-input v-model="form.ADDRESS" style="width: calc(100% - 65px); margin-right: 3px;"></el-input>
                                        <el-button type="info" plain @click="onGPS()">GPS</el-button>
                                    </el-form-item>
                                </el-col>
                            </el-row>
                            <el-row>
                                <el-col :span="12" style="padding: 0 6px;">
                                    <el-form-item label="緯度(ex:25.03475314)" prop="LATI">
                                        <el-input v-model="form.LATI"></el-input>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="12" style="padding: 0 6px;">
                                    <el-form-item label="經度(ex:121.52141519)" prop="LONG">
                                        <el-input v-model="form.LONG"></el-input>
                                    </el-form-item>
                                </el-col>
                            </el-row>
                            <el-row>
                                <el-col :span="12" style="padding: 0 6px;">
                                    <el-form-item label="連絡電話" prop="PHONE_NO">
                                        <el-input v-model="form.PHONE_NO"></el-input>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="12" style="padding: 0 6px;">
                                    <el-form-item label="取得清真認證" prop="HALAL">
                                        <el-select v-model="form.HALAL" style="width:100%;">
                                            <el-option label="NO" value="N"></el-option>
                                            <el-option label="YES" value="Y"></el-option>
                                        </el-select>
                                    </el-form-item>
                                </el-col>
                            </el-row>
                            <el-row>
                                <el-col :span="12" style="padding: 0 6px;">
                                    <el-form-item label="類別" prop="ROLE_TYPE">
                                        <el-select v-model="form.ROLE_TYPE" style="width:100%;" disabled>
                                            <el-option v-for="item in roletypeOptions" :key="item.value" :label="item.label" :value="item.label"></el-option>
                                        </el-select>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="6" style="padding: 0 6px;">
                                    <el-form-item label="付款對象" prop="PAY_PARTY" >
                                        <el-select v-model="form.PAY_PARTY" style="width:100%;" disabled>
                                            <el-option label="門店" value="門店"></el-option>
                                            <el-option label="品牌" value="品牌"></el-option>
                                        </el-select>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="6" style="padding: 0 6px;">
                                    <el-form-item label="儲值金警示水位" prop="ALERT_AMT" >
                                        <el-input-number v-model="form.ALERT_AMT" :controls="false" />
                                    </el-form-item>
                                </el-col>
                            </el-row>
                            <el-row>
                                <el-col style="padding: 0 6px;">
                                    <el-form-item label="注意事項" prop="OUTLET_DESC">
                                        <el-input type="textarea" v-model="form.OUTLET_DESC" :rows="3"></el-input>
                                    </el-form-item>
                                </el-col>
                            </el-row>
                            <el-row>
                                <el-col style="padding: 0 6px;">
                                    <el-form-item label="取件(騎手)注意事項" prop="RIDER_INSTRUCTIONS">
                                        <el-input type="textarea" v-model="form.RIDER_INSTRUCTIONS" :rows="3"></el-input>
                                    </el-form-item>
                                </el-col>
                            </el-row>
                            <el-row>
                                <el-col :span="12" style="padding: 0 6px;">
                                    <el-form-item label="Pandago更新時間" prop="UPDATE_TRN_LGS">
                                        <el-input v-model="form.UPDATE_TRN_LGS" disabled></el-input>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="6" style="padding: 0 6px; display: flex; align-items: flex-end;">
                                    <el-form-item>
                                        <el-button type="info" plain @click="onUpdatePandago()" v-show="IDdisabled">上傳更新</el-button>
                                    </el-form-item>
                                </el-col>
                            </el-row>
                            <el-row>
                                <el-col :span="12" style="padding: 0 6px;">
                                    <el-form-item label="Uber品牌代號" prop="UBER_BRAND_ID">
                                        <el-input v-model="form.UBER_BRAND_ID" disabled></el-input>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="12" style="padding: 0 6px;">
                                    <el-form-item prop="UPDATE_UBER_TIME">
                                        <label slot="label" class="el-form-item__label" style="width:100%;padding-right:0;">
                                            <span>Uber更新時間</span>
                                            <el-button type="info" plain @click="onUpdateUber()" style="width:65px;height:20px;padding:0;float:right;" :disabled="form.ROLE_TYPE!='品牌'">上傳更新</el-button>
                                        </label>
                                        <el-input v-model="form.UPDATE_UBER_TIME" disabled></el-input>
                                    </el-form-item>
                                </el-col>
                            </el-row>
                            <el-row>
                                <el-col style="padding: 0 6px;">
                                    <el-form-item label="服務條款" prop="AGREE_TIME">
                                        <el-checkbox v-model="form.AGREE_TIME" label="我已詳閱並同意" true-label="Y" false-label="N" @change="onCheckboxChange" />
                                        <span>《<span style="color: #00BFFF;text-decoration: underline;cursor:pointer;" @click="onDocDownload">米特物流服務條款</span>》</span>
                                    </el-form-item>
                                </el-col>
                            </el-row>
                        </el-scrollbar>
                    </el-form>

                    <!-- 帳務/發票 -->
                    <el-dialog title="[帳務/發票資料]" width="600px" v-model="dialogInvoiceVisible" top="5vh"
                               center :lock-scroll="false" :close-on-click-modal="false" append-to-body>
                        <el-form :model="form" :rules="rules" ref="formRef" :inline-message="true" label-position="top">
                            <el-row>
                                <el-col :span="12" style="padding: 0 6px;">
                                    <el-form-item label="公司/門店代號">
                                        <el-input v-model="form.VENDOR_ID" disabled></el-input>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="12" style="padding: 0 6px;">
                                    <el-form-item label="屬性別">
                                        <el-select v-model="form.ROLE_TYPE" style="width:100%;" disabled>
                                            <el-option label="門店" value="門店"></el-option>
                                            <el-option label="品牌" value="品牌"></el-option>
                                            <el-option label="餐飲平台" value="餐飲平台"></el-option>
                                            <el-option label="物流公司" value="物流公司"></el-option>
                                        </el-select>
                                    </el-form-item>
                                </el-col>
                            </el-row>
                            <el-row>
                                <el-col :span="12" style="padding: 0 6px;">
                                    <el-form-item label="品牌名稱">
                                        <el-input v-model="form.BRAND_NAME" disabled></el-input>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="12" style="padding: 0 6px;">
                                    <el-form-item label="公司/門店名稱">
                                        <el-input v-model="form.NAME" disabled></el-input>
                                    </el-form-item>
                                </el-col>
                            </el-row>
                            <el-row>
                                <el-col :span="12" style="padding: 0 6px;">
                                    <el-form-item label="買受人統一編號" prop="INV_TAX_ID">
                                        <el-input v-model="form.INV_TAX_ID"></el-input>
                                    </el-form-item>
                                </el-col>
                            </el-row>
                            <el-row>
                                <el-col style="padding: 0 6px;">
                                    <el-form-item label="買受人公司名稱" prop="INV_COMP_NAME">
                                        <el-input v-model="form.INV_COMP_NAME"></el-input>
                                    </el-form-item>
                                </el-col>
                            </el-row>
                            <el-row>
                                <el-col :span="12" style="padding: 0 6px;">
                                    <el-form-item label="帳務-聯絡人" prop="AC_CONTACT">
                                        <el-input v-model="form.AC_CONTACT"></el-input>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="12" style="padding: 0 6px;">
                                    <el-form-item label="聯絡電話" prop="AC_TEL_NO">
                                        <el-input v-model="form.AC_TEL_NO"></el-input>
                                    </el-form-item>
                                </el-col>
                            </el-row>
                            <el-row>
                                <el-col style="padding: 0 6px;">
                                    <el-form-item label="帳單/發票寄送地址" prop="AC_ADDRESS">
                                        <el-input v-model="form.AC_ADDRESS"></el-input>
                                    </el-form-item>
                                </el-col>
                            </el-row>
                            <el-row>
                                <el-col style="padding: 0 6px;">
                                    <el-form-item label="電子郵件" prop="AC_MAIL_ADDR">
                                        <el-input v-model="form.AC_MAIL_ADDR"></el-input>
                                    </el-form-item>
                                </el-col>
                            </el-row>
                            <el-row>
                                <el-col style="padding: 0 6px;">
                                    <el-form-item label="注意事項" prop="AC_REMARKS">
                                        <el-input type="textarea" v-model="form.AC_REMARKS" :rows="3"></el-input>
                                    </el-form-item>
                                </el-col>
                            </el-row>
                            <el-row>
                                <el-col :span="3" style="padding: 0 6px;">
                                    <el-text class="mx-1">建檔人</el-text>
                                </el-col>
                                <el-col :span="9" style="padding: 0 6px;">
                                    <el-text class="mx-1">{{ form.CREATE_USER }}</el-text>
                                </el-col>
                                <el-col :span="3" style="padding: 0 6px;">
                                    <el-text class="mx-1">修改人</el-text>
                                </el-col>
                                <el-col :span="9" style="padding: 0 6px;">
                                    <el-text class="mx-1">{{ form.EDIT_USER }}</el-text>
                                </el-col>
                            </el-row>
                            <el-row>
                                <el-col :span="9" :offset="3" style="padding: 0 6px;">
                                    <el-text class="mx-1">{{ form.CREATE_TIME }}</el-text>
                                </el-col>
                                <el-col :span="9" :offset="3" style="padding: 0 6px;">
                                    <el-text class="mx-1">{{ form.EDIT_TIME }}</el-text>
                                </el-col>
                            </el-row>
                        </el-form>
                        <template #footer class="dialog-footer">
                            <el-button type="info" @click="dialogInvoiceVisible = false" style="width: 150px;">取消</el-button>
                            <el-button type="primary" @click="onInvoiceSubmit" style="width: 150px;">存檔</el-button>
                        </template>
                    </el-dialog>

                    <el-dialog width="600px" v-model="dialogRemindVisible" center :lock-scroll="false" :close-on-click-modal="false" append-to-body>
                        <el-row>
                            <el-col :span="12">
                                <img src="@/assets/qrcode.jpg" style="width: 150px; margin: 0 50px;">
                            </el-col>
                            <el-col :span="11">
                                <el-text class="mx-1" style="font-size: 16px">
                                    感謝您完成帳號資訊登錄!<br />
                                    提醒您請加入官方客服LINE@，以便您後續進行儲值、查詢與客服支援喔。
                                </el-text>
                            </el-col>
                        </el-row>
                        <template #footer class="dialog-footer">
                            <el-button type="primary" @click="dialogRemindVisible=false" style="width: 150px;">OK</el-button>
                        </template>
                    </el-dialog>

                    <template #footer class="dialog-footer">
                        <el-button type="info" @click="dialogInvoiceVisible=true;" style="width: 150px;">帳務/發票</el-button>
                        <el-button type="primary" @click="onSubmit('form')" style="width: 150px;">存檔</el-button>
                    </template>
                </el-dialog>
            </div>
        </div>
    </transition>
</template>

<script setup>
    import { ref, reactive, onBeforeMount, onMounted, nextTick } from 'vue';
    import { ElMessage, ElMessageBox } from 'element-plus';
    import { useDownload } from '@/composables/download';
    import $api from '@/utils/axios';
    import { useStore } from "vuex";
    import { User } from '@element-plus/icons-vue';
    const store = useStore();

    const showMain = ref(true);//顯示主頁面
    const dialogTitle = ref('[公司/門店基本資料]');//dialog標題
    const dialogFormVisible = ref(true);//顯示dialog
    const dialogInvoiceVisible = ref(false);//顯示[帳務/發票]dialog
    const dialogRemindVisible = ref(false);//顯示[提醒]dialog
    const IDdisabled = ref(true);//編輯時ID狀態
    const formRef = ref(null);
    const formData = ref(null);

    const readDoc = ref(null); //是否已閱讀<<服務條款>>

    const brandOptions = ref([]);
    const custcodeOptions = ref([]);
    const roletypeOptions = ref([]);

    const form = ref({
        OUTLET_SEQ: '',
        VENDOR_ID: '',
        CUST_CODE: localStorage.getItem("CustCode"),
        DISABLE_FG: 'N',
        BRAND_NAME: '',
        NAME: '',
        ROLE_TYPE: '門店',
        PAY_PARTY: '門店',
        PAY_VENDOR: '',
        ALERT_AMT: '',
        ADDRESS: '',
        LATI: '',
        LONG: '',
        PHONE_NO: '',
        HALAL: 'N',
        OUTLET_DESC: '',
        RIDER_INSTRUCTIONS: '',
        UPDATE_TRN_LGS: '', //Pandago更新時間
        UBER_BRAND_ID: '', //Uber品牌代號
        UPDATE_UBER_TIME: '', //Uber更新時間
        AGREE_TIME: '',
        AGREE_DOC_SEQ: '',
        DOC_NAME: '',
        DOC_FILE: '',
        CREATE_USER: '',
        CREATE_TIME: '',
        INV_TAX_ID: '', //[帳務/發票資料]
        INV_COMP_NAME: '',
        AC_CONTACT: '',
        AC_TEL_NO: '',
        AC_ADDRESS: '',
        AC_MAIL_ADDR: '',
        AC_REMARKS: '',
        EDIT_USER: '',
        EDIT_TIME: '',
    });

    const rules = reactive({
        CUST_CODE: [{ required: true, message: '請選擇餐飲平台', trigger: 'blur' }],
        DISABLE_FG: [{ required: true, message: '請選擇公司/門店狀態', trigger: 'blur' }],
        BRAND_NAME: [{ required: true, message: '請選擇品牌名稱', trigger: 'blur' }],
        NAME: [{ required: true, message: '請輸入公司/門店名稱', trigger: 'blur' }],
        ROLE_TYPE: [{ required: true, message: '請選擇屬性別', trigger: 'blur' }],
        CURRENCY: [{ required: true, message: '請輸入幣別', trigger: 'blur' }],
        LOCALE: [{ required: true, message: '請輸入語系', trigger: 'blur' }],
        ADDRESS: [{ required: true, message: '請輸入地址', trigger: 'blur' }],
        LATI: [{ required: true, message: '請輸入緯度', trigger: 'blur' }],
        LONG: [{ required: true, message: '請輸入經度', trigger: 'blur' }],
        PHONE_NO: [{ required: true, message: '請輸入連絡電話', trigger: 'blur' }],
        HALAL: [{ required: true, message: '請選擇清真認證', trigger: 'blur' }],
        OUTLET_DESC: [{ required: true, message: '請輸入注意事項', trigger: 'blur' }],
        RIDER_INSTRUCTIONS: [{ required: true, message: '請輸入取件(騎手)注意事項', trigger: 'blur' }],
    });

    let roundDecimal = function (val, precision) {
        return Math.round(Math.round(val * Math.pow(10, (precision || 0) + 1)) / 10) / Math.pow(10, (precision || 0));
    }

    // 取經緯度(勤崴OpenApi)
    const onGPS = () => {
        var addr = form.value.ADDRESS;
        if (addr == null || addr == '') {
            formRef.value.validateField('ADDRESS', () => null)
        } else {
            $api.GET('/api/Outlet/GetLatLng', {
                ADDRESS: addr, URL_ADDR: '/CompData'
            }).then((response) => {
                //console.log("GPS:", response);
                form.value.LATI = roundDecimal(response.lat, 8).toString();
                form.value.LONG = roundDecimal(response.lng, 8).toString();
            });
        }
    }

    //將資料更新到Pandago
    const onUpdatePandago = () => {
        formRef.value.validate((valid) => {
            if (valid) {
                form.value.PHONE_NO = form.value.PHONE_NO.replaceAll("-", "");
                if (form.value.PHONE_NO.substring(0, 1) == "0") {
                    form.value.PHONE_NO = "+886" + form.value.PHONE_NO.substring(1, (form.value.PHONE_NO.length));
                }
                var today = new Date();
                const formData = JSON.parse(JSON.stringify(form.value));
                formData.UPDATE_TRN_LGS = today.toLocaleString([], { year: "numeric", month: "2-digit", day: "2-digit", hour12: false, hour: "2-digit", minute: "2-digit", second: "2-digit" });
                
                $api.POST('/api/Outlet/UpdatePandago/', formData
                ).then((res) => {
                    if (res == "1") {
                        ElMessageBox.alert('上傳成功!', '提示', {
                            confirmButtonText: '確定'
                        });
                        form.value.UPDATE_TRN_LGS = formData.UPDATE_TRN_LGS; //更新pandago上傳時間
                    } else {
                        console.log(res);
                        var message = (res == "0" || res == "-1") ? "" : "<br />" + res;
                        ElMessageBox.alert('上傳失敗!' + message, '提示', {
                            confirmButtonText: '確定',
                            dangerouslyUseHTMLString: true,
                        });
                    }
                }).catch((error) => {
                    console.log(error);
                });
            }
        })
    }

    //將資料更新到Uber
    const onUpdateUber = () => {

    }

    const onCheckboxChange = (val) => {
        if (!readDoc.value) form.value.AGREE_TIME = 'N';
        if (readDoc.value && val == 'Y') {
            $api.POST('/api/Outlet/Update', {
                DOC_SEQ: form.value.AGREE_DOC_SEQ, OUTLET_SEQ: form.value.OUTLET_SEQ
            });
        }
    }

    const onDocDownload = () => {
        useDownload('/api/DocSet/Download?DOC_SEQ=' + form.value.AGREE_DOC_SEQ, `${form.value.DOC_NAME}.${form.value.DOC_FILE.split('.')[1]}`);
        readDoc.value = "Y";
    }

    const onSubmit = () => {
        formRef.value.validate((valid) => {
            if (valid) {
                let obj = {};
                obj = brandOptions.value.find((item) => {
                    return item.label === form.value.BRAND_NAME;
                });
                if (form.value.PAY_PARTY == "品牌") form.value.PAY_VENDOR = obj.value;
                form.value.PHONE_NO = form.value.PHONE_NO.replaceAll("-", "");
                if (form.value.PHONE_NO.substring(0, 1) == "0") {
                    form.value.PHONE_NO = "+886" + form.value.PHONE_NO.substring(1, (form.value.PHONE_NO.length));
                }
                $api.POST('/api/Outlet/Edit', form.value
                ).then((res) => {
                    if (res > 0) {
                        dialogRemindVisible.value = true;
                    } else {
                        ElMessageBox.alert('修改失敗', '提示', {
                            confirmButtonText: '確定'
                        });
                    }
                });
            }
        });
    };

    const onInvoiceSubmit = () => {
        formRef.value.validate((valid) => {
            if (valid) {
                $api.POST('/api/Outlet/SaveInvoice', form.value
                ).then((res) => {
                    if (res > 0) {
                        ElMessageBox.alert('儲存成功', '提示', {
                            confirmButtonText: '確定'
                        });
                    } else {
                        ElMessageBox.alert('儲存失敗', '提示', {
                            confirmButtonText: '確定'
                        });
                    }
                });
            }
        });
    }

    const getOptions = async () => {
        $api.GET('/api/Outlet/GetBrandOptions')
            .then((response) => {
                brandOptions.value = response;
            });
        $api.GET('/api/Outlet/GetCustCodeOptions')
            .then((response) => {
                custcodeOptions.value = response;
            });
    };

    onBeforeMount(() => {
        //options
        getOptions();

        $api.GET('/api/Outlet/GetCompData'
        ).then((response) => {
            form.value = response;
            if(form.value.AGREE_TIME != "" && form.value.AGREE_TIME != null){
                form.value.AGREE_TIME = "Y";
            }else{
                form.value.AGREE_TIME = "N";
            }
            console.log(response);
        });

        switch (localStorage.getItem("VendorType")) {
            case "門店":
                roletypeOptions.value = [{ value: '門店', label: '門店' }];
                break;
            case "品牌":
            case "餐飲平台":
                roletypeOptions.value = [{ value: '門店', label: '門店' }, { value: '品牌', label: '品牌' }];
                break;
            default:
                roletypeOptions.value = [{ value: '門店', label: '門店' }, { value: '品牌', label: '品牌' },
                { value: '餐飲平台', label: '餐飲平台' }, { value: '運輸公司', label: '運輸公司' }, { value: '平台管理', label: '平台管理' }];
                break;
        }
    });

</script>
<style>
    #pane-\/CompData .el-overlay, .el-overlay-dialog {
        position: relative;
    }
</style>